import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * System vendor invoice audit logs (admin / System Invoice Management).
 */
export const getSystemPoInvoiceAuditLogs = async (invoiceNumber) => {
  try {
    const encoded = encodeURIComponent(invoiceNumber);
    const response = await apiClient.get(
      `/systemInvoiceManagement/workflow/invoice/audit-logs/${encoded}`
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
